import {
  Directive,
  Input,
  Output,
  NgZone,
  ElementRef,
  EventEmitter,
  OnInit,
  OnChanges,
  HostListener,
  DoCheck,
  SimpleChanges
} from '@angular/core';
import {AngularGooglePlaceService} from '../services/index';
import {Address} from '../models/index';
declare let google: any;
export class AngularGooglePlaceDirective implements OnInit {
  changelogs: Array<string> = [];
   options: any;

   CountryCodes: EventEmitter<any> = new EventEmitter();
   TypesOptions: EventEmitter<any> = new EventEmitter();

  // unformatted address
   setAddress: EventEmitter<any> = new EventEmitter();
  // formatted address
   FormatAddress: EventEmitter<any> = new EventEmitter();

   street_number: EventEmitter<any> = new EventEmitter();
   postal_code: EventEmitter<any> = new EventEmitter();
   country: EventEmitter<any> = new EventEmitter();
   lat: EventEmitter<any> = new EventEmitter();
   lng: EventEmitter<any> = new EventEmitter();
   adr_address: EventEmitter<any> = new EventEmitter();
   formatted_address: EventEmitter<any> = new EventEmitter();
   name: EventEmitter<any> = new EventEmitter();
   place_id: EventEmitter<any> = new EventEmitter();
   types: EventEmitter<any> = new EventEmitter();
   url: EventEmitter<any> = new EventEmitter();
   utc_offset: EventEmitter<any> = new EventEmitter();
   vicinity: EventEmitter<any> = new EventEmitter();
   photos: EventEmitter<any> = new EventEmitter();
   street: EventEmitter<any> = new EventEmitter();
   city: EventEmitter<any> = new EventEmitter();
   state: EventEmitter<any> = new EventEmitter();
   district: EventEmitter<any> = new EventEmitter();


  /*
   NOT USED YET
   @Output() intersection: EventEmitter<any>  = new EventEmitter();
   @Output() political: EventEmitter<any>  = new EventEmitter();
   @Output() colloquial_area: EventEmitter<any>  = new EventEmitter();
   @Output() ward: EventEmitter<any>  = new EventEmitter();
   @Output() administrative_area_level_3: EventEmitter<any>  = new EventEmitter();
   @Output() administrative_area_level_4: EventEmitter<any>  = new EventEmitter();
   @Output() administrative_area_level_5: EventEmitter<any>  = new EventEmitter();
   @Output() sublocality: EventEmitter<any>  = new EventEmitter();
   @Output() sublocality_level_1: EventEmitter<any>  = new EventEmitter();
   @Output() sublocality_level_2: EventEmitter<any>  = new EventEmitter();
   @Output() sublocality_level_3: EventEmitter<any>  = new EventEmitter();
   @Output() sublocality_level_4: EventEmitter<any>  = new EventEmitter();
   @Output() sublocality_level_5: EventEmitter<any>  = new EventEmitter();
   @Output() neighborhood: EventEmitter<any>  = new EventEmitter();
   @Output() premise: EventEmitter<any>  = new EventEmitter();
   @Output() subpremise: EventEmitter<any>  = new EventEmitter();
   @Output() natural_feature: EventEmitter<any>  = new EventEmitter();
   @Output() airport: EventEmitter<any>  = new EventEmitter();
   @Output() park: EventEmitter<any>  = new EventEmitter();
   @Output() point_of_interest: EventEmitter<any>  = new EventEmitter();
   @Output() floor: EventEmitter<any>  = new EventEmitter();
   @Output() establishment: EventEmitter<any>  = new EventEmitter();
   @Output() parking: EventEmitter<any>  = new EventEmitter();
   @Output() post_box: EventEmitter<any>  = new EventEmitter();
   @Output() room: EventEmitter<any>  = new EventEmitter();
   @Output() postal_town: EventEmitter<any>  = new EventEmitter();
   @Output() bus_station: EventEmitter<any>  = new EventEmitter();
   @Output() train_station: EventEmitter<any>  = new EventEmitter();
   @Output() transit_station: EventEmitter<any>  = new EventEmitter();
   */

  autocomplete: any;

  trigger: any;

  place: Address;
/**
 * @param {?} el
 * @param {?} service
 * @param {?} ngZone
 */
constructor(private el: ElementRef,
private service: AngularGooglePlaceService,
private ngZone: NgZone) {
  }
/**
 * @param {?} target
 * @return {?}
 */
onFocus(target: any) {
      this.setAutocompleteAndInvokeEvent(this.options);
  }
/**
 * @return {?}
 */
ngOnInit() {

    this.CountryCodes.emit(this.service.countryIsoCode());
    this.TypesOptions.emit(this.service.typesOptions());


    if (typeof google === 'undefined' ) {
      console.error(`google place api is not loaded at this time, angular-google-place won't work`);
      return;
    }
    this.setAutocompleteAndInvokeEvent(this.options);

  }
/**
 * @param {?} options
 * @return {?}
 */
setAutocompleteAndInvokeEvent(options: any) {
    this.autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, options);
    this.trigger = this.autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        this.place = this.autocomplete.getPlace();
        if (this.place && this.place.place_id) {
          this.invokeEvent();
        }
      });
    });
  }
/**
 * @return {?}
 */
invokeEvent() {
    this.setAddress.emit(this.place);

    const /** @type {?} */ street_number = this.service.street_number(this.place.address_components);
    this.street_number.emit( street_number);

    const /** @type {?} */ street = this.service.street(this.place.address_components);
    this.street.emit(street);

    const /** @type {?} */ city = this.service.city(this.place.address_components);
    this.city.emit(city);

    const /** @type {?} */ state = this.service.state(this.place.address_components);
    this.state.emit(state);

    const /** @type {?} */ country = this.service.country(this.place.address_components);
    this.country.emit(country);

    const /** @type {?} */ postal_code  = this.service.postal_code(this.place.address_components);
    this.postal_code.emit(postal_code);

    const /** @type {?} */ district = this.service.administrative_area_level_2(this.place.address_components);
    this.district.emit(district);

    const /** @type {?} */ lat = this.place.geometry.location.lat();
    this.lat.emit( lat);

    const /** @type {?} */ lng = this.place.geometry.location.lng();
    this.lng.emit(lng);

    const /** @type {?} */ adr_address = this.place.adr_address;
    this.adr_address.emit(adr_address);

    const /** @type {?} */ formatted_address = this.place.formatted_address;
    this.formatted_address.emit(formatted_address);

    const /** @type {?} */ name = this.place.name;
    this.name.emit(name);

    const /** @type {?} */ place_id  = this.place.place_id;
    this.place_id.emit(place_id);

    const /** @type {?} */ types = this.place.types;
    this.types.emit(types);

    const /** @type {?} */ url = this.place.url;
    this.url.emit(url);

    const /** @type {?} */ utc_offset = this.place.utc_offset;
    this.utc_offset.emit(utc_offset);

    const /** @type {?} */ vicinity = this.place.vicinity;
    this.vicinity.emit(vicinity);

    const /** @type {?} */ photos = this.place.photos;
    this.photos.emit(photos);

    console.log('here');
    this.FormatAddress.emit({
      'street_number' : street_number,
      'street' : street,
      'city' : city,
      'state' : state,
      'country' : country,
      'postal_code' : postal_code,
      'district' : district ,
      'lat' : lat,
      'lng' : lng,
    });

    /*
     DEPRECATED SINCE 2014
     this.place.id
     reference
     */


    /*
     NOT USED YET

     this.intersection.emit(this.service.intersection(this.place.address_components) ? this.service.intersection(this.place.address_components) : null)
     this.political.emit(this.service.political(this.place.address_components) ? this.service.political(this.place.address_components) : null)
     this.colloquial_area.emit(this.service.colloquial_area(this.place.address_components) ? this.service.colloquial_area(this.place.address_components) : null)

     this.ward.emit(this.service.ward(this.place.address_components) ? this.service.ward(this.place.address_components) : null)

     this.administrative_area_level_3.emit(this.service.administrative_area_level_3(this.place.address_components) ? this.service.administrative_area_level_3(this.place.address_components) : null)
     this.administrative_area_level_4.emit(this.service.administrative_area_level_4(this.place.address_components) ? this.service.administrative_area_level_4(this.place.address_components) : null)
     this.administrative_area_level_5.emit(this.service.administrative_area_level_5(this.place.address_components) ? this.service.administrative_area_level_5(this.place.address_components) : null)

     this.sublocality.emit(this.service.sublocality(this.place.address_components) ? this.service.sublocality(this.place.address_components) : null)
     this.sublocality_level_1.emit(this.service.sublocality_level_1(this.place.address_components) ?
     this.service.sublocality_level_1(this.place.address_components) : null);
     this.sublocality_level_2.emit(this.service.sublocality_level_2(this.place.address_components) ?
     this.service.sublocality_level_2(this.place.address_components) : null);
     this.sublocality_level_3.emit(this.service.sublocality_level_3(this.place.address_components) ?
     this.service.sublocality_level_3(this.place.address_components) : null);
     this.sublocality_level_4.emit(this.service.sublocality_level_4(this.place.address_components) ?
     this.service.sublocality_level_4(this.place.address_components) : null);
     this.sublocality_level_5.emit(this.service.sublocality_level_5(this.place.address_components) ?
     this.service.sublocality_level_5(this.place.address_components) : null);

     this.neighborhood.emit(this.service.neighborhood(this.place.address_components) ? this.service.neighborhood(this.place.address_components) : null)
     this.premise.emit(this.service.premise(this.place.address_components) ? this.service.premise(this.place.address_components) : null)
     this.subpremise.emit(this.service.subpremise(this.place.address_components) ? this.service.subpremise(this.place.address_components) : null)
     this.natural_feature.emit(this.service.natural_feature(this.place.address_components) ? this.service.natural_feature(this.place.address_components) : null)
     this.airport.emit(this.service.airport(this.place.address_components) ? this.service.airport(this.place.address_components) : null)
     this.park.emit(this.service.park(this.place.address_components) ? this.service.park(this.place.address_components) : null)
     this.point_of_interest.emit(this.service.point_of_interest(this.place.address_components) ? this.service.point_of_interest(this.place.address_components) : null)
     this.floor.emit(this.service.floor(this.place.address_components) ? this.service.floor(this.place.address_components) : null)
     this.establishment.emit(this.service.establishment(this.place.address_components) ? this.service.establishment(this.place.address_components) : null)
     this.parking.emit(this.service.parking(this.place.address_components) ? this.service.parking(this.place.address_components) : null)
     this.post_box.emit(this.service.post_box(this.place.address_components) ? this.service.post_box(this.place.address_components) : null)
     this.postal_town.emit(this.service.postal_town(this.place.address_components) ? this.service.postal_town(this.place.address_components) : null)
     this.room.emit(this.service.room(this.place.address_components) ? this.service.room(this.place.address_components) : null)
     this.bus_station.emit(this.service.bus_station(this.place.address_components) ? this.service.bus_station(this.place.address_components) : null)
     this.train_station.emit(this.service.train_station(this.place.address_components) ? this.service.train_station(this.place.address_components) : null)
     this.transit_station.emit(this.service.transit_station(this.place.address_components) ? this.service.transit_station(this.place.address_components) : null)
     */
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[angularGooglePlace]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: AngularGooglePlaceService, },
{type: NgZone, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'options': [{ type: Input, args: ['options', ] },],
'CountryCodes': [{ type: Output },],
'TypesOptions': [{ type: Output },],
'setAddress': [{ type: Output },],
'FormatAddress': [{ type: Output },],
'street_number': [{ type: Output },],
'postal_code': [{ type: Output },],
'country': [{ type: Output },],
'lat': [{ type: Output },],
'lng': [{ type: Output },],
'adr_address': [{ type: Output },],
'formatted_address': [{ type: Output },],
'name': [{ type: Output },],
'place_id': [{ type: Output },],
'types': [{ type: Output },],
'url': [{ type: Output },],
'utc_offset': [{ type: Output },],
'vicinity': [{ type: Output },],
'photos': [{ type: Output },],
'street': [{ type: Output },],
'city': [{ type: Output },],
'state': [{ type: Output },],
'district': [{ type: Output },],
'onFocus': [{ type: HostListener, args: ['focus', ['$event.target'], ] },],
};
}

function AngularGooglePlaceDirective_tsickle_Closure_declarations() {
/** @type {?} */
AngularGooglePlaceDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AngularGooglePlaceDirective.ctorParameters;
/** @type {?} */
AngularGooglePlaceDirective.propDecorators;
/** @type {?} */
AngularGooglePlaceDirective.prototype.changelogs;
/** @type {?} */
AngularGooglePlaceDirective.prototype.options;
/** @type {?} */
AngularGooglePlaceDirective.prototype.CountryCodes;
/** @type {?} */
AngularGooglePlaceDirective.prototype.TypesOptions;
/** @type {?} */
AngularGooglePlaceDirective.prototype.setAddress;
/** @type {?} */
AngularGooglePlaceDirective.prototype.FormatAddress;
/** @type {?} */
AngularGooglePlaceDirective.prototype.street_number;
/** @type {?} */
AngularGooglePlaceDirective.prototype.postal_code;
/** @type {?} */
AngularGooglePlaceDirective.prototype.country;
/** @type {?} */
AngularGooglePlaceDirective.prototype.lat;
/** @type {?} */
AngularGooglePlaceDirective.prototype.lng;
/** @type {?} */
AngularGooglePlaceDirective.prototype.adr_address;
/** @type {?} */
AngularGooglePlaceDirective.prototype.formatted_address;
/** @type {?} */
AngularGooglePlaceDirective.prototype.name;
/** @type {?} */
AngularGooglePlaceDirective.prototype.place_id;
/** @type {?} */
AngularGooglePlaceDirective.prototype.types;
/** @type {?} */
AngularGooglePlaceDirective.prototype.url;
/** @type {?} */
AngularGooglePlaceDirective.prototype.utc_offset;
/** @type {?} */
AngularGooglePlaceDirective.prototype.vicinity;
/** @type {?} */
AngularGooglePlaceDirective.prototype.photos;
/** @type {?} */
AngularGooglePlaceDirective.prototype.street;
/** @type {?} */
AngularGooglePlaceDirective.prototype.city;
/** @type {?} */
AngularGooglePlaceDirective.prototype.state;
/** @type {?} */
AngularGooglePlaceDirective.prototype.district;
/** @type {?} */
AngularGooglePlaceDirective.prototype.autocomplete;
/** @type {?} */
AngularGooglePlaceDirective.prototype.trigger;
/** @type {?} */
AngularGooglePlaceDirective.prototype.place;
/** @type {?} */
AngularGooglePlaceDirective.prototype.el;
/** @type {?} */
AngularGooglePlaceDirective.prototype.service;
/** @type {?} */
AngularGooglePlaceDirective.prototype.ngZone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
